module.exports = __webpack_public_path__ + "img/3-2-field.34d84700.jpg";